export const selectCulturesAvailable = (state) => state.i18n.available;

export const selectCurrentLanguageId = (state) => state.i18n.languageId;

export const selectCurrentLanguageCode = (state) => state.i18n.languageCode;
